import React, { useState } from 'react';
import { schedule } from '../mockData';
import { Filter } from 'lucide-react';

const Schedule = () => {
  const [selectedDiscipline, setSelectedDiscipline] = useState('All');

  const disciplines = ['All', 'MMA', 'Kickboxing', 'BJJ', 'Combat Fitness', 'Karate'];

  const daysOfWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

  const filteredSchedule = selectedDiscipline === 'All'
    ? schedule
    : schedule.filter(item => item.discipline === selectedDiscipline);

  const groupedSchedule = daysOfWeek.reduce((acc, day) => {
    acc[day] = filteredSchedule.filter(item => item.day === day);
    return acc;
  }, {});

  return (
    <div className="bg-[#1a1c1b] min-h-screen pt-24 pb-20">
      <div className="container mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-[#d9fb06] font-black text-5xl md:text-7xl uppercase mb-4">
            Class Schedule
          </h1>
          <p className="text-[#dfddd6] text-xl max-w-3xl mx-auto">
            Find your perfect training time with morning and evening sessions available
          </p>
        </div>

        {/* Discipline Filter */}
        <div className="mb-8 flex items-center justify-center">
          <div className="flex items-center gap-2 text-[#d9fb06] mr-4">
            <Filter size={20} />
            <span className="font-semibold uppercase text-sm">Filter:</span>
          </div>
          <div className="flex flex-wrap gap-3">
            {disciplines.map((discipline) => (
              <button
                key={discipline}
                onClick={() => setSelectedDiscipline(discipline)}
                className={`px-4 py-2 rounded-full font-semibold uppercase text-xs transition-all ${
                  selectedDiscipline === discipline
                    ? 'bg-[#d9fb06] text-[#1a1c1b]'
                    : 'bg-[#302f2c] text-[#888680] hover:bg-[#3f4816] hover:text-[#d9fb06]'
                }`}
              >
                {discipline}
              </button>
            ))}
          </div>
        </div>

        {/* Schedule Grid */}
        <div className="space-y-8">
          {daysOfWeek.map((day) => (
            <div key={day} className="bg-[#302f2c] border border-[#3f4816] overflow-hidden">
              <div className="bg-[#3f4816] px-6 py-4">
                <h2 className="text-[#d9fb06] font-black text-2xl uppercase">{day}</h2>
              </div>
              <div className="p-6">
                {groupedSchedule[day].length > 0 ? (
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {groupedSchedule[day].map((item, index) => (
                      <div
                        key={index}
                        className="bg-[#1a1c1b] border border-[#3f4816] p-4 hover:border-[#d9fb06] transition-colors"
                      >
                        <div className="flex items-center justify-between mb-2">
                          <span className="text-[#d9fb06] font-bold text-lg">
                            {item.time}
                          </span>
                        </div>
                        <h3 className="text-[#dfddd6] font-semibold text-xl mb-1">
                          {item.discipline}
                        </h3>
                        <p className="text-[#888680] text-sm uppercase tracking-wide mb-1">
                          {item.level}
                        </p>
                        {item.instructor && (
                          <p className="text-[#d9fb06] text-sm">
                            Coach: {item.instructor}
                          </p>
                        )}
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="text-[#888680] text-center py-4">
                    No classes scheduled for this day
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-12 text-center bg-[#3f4816] py-12 px-6 rounded-lg">
          <h3 className="text-[#d9fb06] font-black text-3xl uppercase mb-4">
            Ready to Start Training?
          </h3>
          <p className="text-[#dfddd6] mb-6 max-w-2xl mx-auto">
            Book your first class and experience world-class MMA training
          </p>
          <a
            href="/book"
            className="bg-[#d9fb06] text-[#1a1c1b] px-8 py-4 rounded-full font-bold uppercase text-sm hover:opacity-90 transition-all hover:scale-105 inline-flex items-center justify-center"
          >
            Book Your Class Now
          </a>
        </div>
      </div>
    </div>
  );
};

export default Schedule;
